var _path, _ellipse, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDoor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 65C50.4493 65 65 50.4493 65 32.5C65 14.5507 50.4493 0 32.5 0C14.5507 0 0 14.5507 0 32.5C0 50.4493 14.5507 65 32.5 65Z",
    fill: "#BCD9C9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 33,
    rx: 18.5,
    ry: 20,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 33,
    r: 20.25,
    stroke: "#727D79",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7981 41.6857V41.7357H38.8481H42.341C42.676 41.7357 42.95 42.0092 42.95 42.3429C42.95 42.6765 42.676 42.95 42.341 42.95H38.1891H20.659C20.324 42.95 20.05 42.6765 20.05 42.3429C20.05 42.0092 20.324 41.7357 20.659 41.7357H23.8553H23.9053V41.6857V20.6571C23.9053 20.3235 24.1793 20.05 24.5143 20.05H38.1891C38.5241 20.05 38.7981 20.3235 38.7981 20.6571V41.6857ZM37.5301 41.7357H37.5801V41.6857V21.3143V21.2643H37.5301H25.1733H25.1233V21.3143V41.6857V41.7357H25.1733H37.5301ZM36.195 31.7629C36.195 32.2608 35.7891 32.6657 35.2894 32.6657C34.7897 32.6657 34.3838 32.2608 34.3838 31.7629C34.3838 31.2649 34.7897 30.86 35.2894 30.86C35.7891 30.86 36.195 31.2649 36.195 31.7629Z",
    fill: "#EE8322",
    stroke: "white",
    strokeWidth: 0.1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDoor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-door.a2a347e210d449dec439ef042500eba2.svg";